<template>
    <v-tooltip bottom :open-on-hover="true">
        <template v-slot:activator="{ on, attrs }">
            <v-card v-bind="attrs" v-on="on" :elevation="img || file ? 3 : 0" :ripple="{ class: 'info-ripple' }" @click="openFileDialog"
                class="upload-area">
                <div class="content-area">
                    <img :src="faviconImg" />
                    <span>{{ fileName || label }}</span>
                    <input style="display: none;" @change="fileSelect" type="file" :accept="acceptString" :id="id"
                        :ref="id" />
                </div>
            </v-card>
        </template>
        <span v-if="img || file">(Remove Favicon)</span>
        <span v-else>(Upload Favicon)</span>
    </v-tooltip>
</template>

<style lang="scss">
@import '../../styles/styles.scss';
</style>

<script>
import InactiveRealDeal from '../../assets/Real-Deal-Inactive.svg';

export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        acceptString: {
            type: String,
            default: '.jpg,.png,.svg' //all images.
        },
        img: {
            type: String,
            defaut: ''
        }
    },
    data: () => ({
        file: null,
        fileImg: null
    }),
    methods: {
        openFileDialog() {
            if (this.file) {
                this.file = null;
                this.fileImg = null;
            } else {
                this.$refs[this.id].click();
            }
        },
        fileSelect(events) {
            const uploadedFile = events.target.files[0];
            if (uploadedFile.size < 5242880) {
                const reader = new FileReader()
                reader.onload = event => {
                    this.fileImg = event.target.result;
                }
                reader.readAsDataURL(uploadedFile)
                this.file = uploadedFile;
                this.$emit('file-upload', uploadedFile);
            } else {
                alert('error file too big');
            }
        }
    },
    computed: {
        fileName() {
            return this.file ? this.file?.name : '';
        },
        faviconImg() {
            return this.fileImg || this.img || InactiveRealDeal;
        }
    }
}
</script>
